import {
  GET_PERMISSION,
  GET_PERMISSION_SUCCESS,
  GET_PERMISSION_ERROR,
} from "./constants";

export const getPermission = (payload) => ({
  type: GET_PERMISSION,
  payload,
});

export const getPermissionSuccess = (payload) => ({
  type: GET_PERMISSION_SUCCESS,
  payload,
});

export const getPermissionError = (payload) => ({
  type: GET_PERMISSION_ERROR,
  payload,
});
